const getters = {
  getReminders: (state) => state.reminders,
  getCheckNotificationInterval: (state) => state.checkNotificationInterval,
  isMyTimeInactive(state) {
    return state.timeInactive;
  },
};

export default getters;
